export const swrOptions = {
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    if (error.status === 403) return;

    // Retry after 5 seconds.
    //setTimeout(() => revalidate({ retryCount }), 5000)
  },
};
